import { Injectable, computed, inject, signal } from '@angular/core';
import {
  CollectionReference,
  Firestore,
  QueryConstraint,
  collection,
  collectionData,
  collectionSnapshots,
  doc,
  onSnapshot,
  query,
  setDoc,
  updateDoc,
  where,
} from '@angular/fire/firestore';

import { catchError, map, of } from 'rxjs';
import { Office } from './model';

@Injectable({
  providedIn: 'root',
})
export class OfficeService {
  firestore: Firestore = inject(Firestore);
  office = signal<Office | null>(null);
  officePath = computed(() => {
    const path = 'office/' + this.office()?._documentId;
    console.log('officePath: ' + path);
    return path;
  });

  constructor() {
    // const officeFromSession: string | null = sessionStorage.getItem('Office');
    const officeFromSession: string | null = localStorage.getItem('Office');
    if (officeFromSession) {
      const office: Office = <Office>JSON.parse(officeFromSession);
      this.office.set(office);
      console.log('[data:session] office', { officePath: this.officePath(), office });
    }

    // effect(() => {
    //   sessionStorage.setItem('officePath', this.officePath());
    // });
  }

  createOffice(office: Office, userUid: string) {
    const newOfficeDoc = doc(this.firestore, 'office/' + userUid);
    return setDoc(newOfficeDoc, office).then(result => {
      console.log('createOffice result', result);
      office._documentId = userUid;
      this.setOffice(office);
    });
    // return addDoc(collection(this.firestore, 'office'), office).then(result => {
    //   console.log('createOffice result', result);
    // });
  }

  updateOffice(office: Office) {
    const { _documentId, ...officeData } = office;
    const docRef = doc(this.firestore, 'office/', _documentId!);
    console.log('updateOffice ' + _documentId, { office, docRef });

    return updateDoc(docRef, officeData).then(result => {
      this.setOffice(office);
      console.log('updateOffice result', result);
    });
  }

  getOffice(userUid: string) {
    console.log('getOffice');
    const officeDocRef = doc(this.firestore, 'office', userUid);
    onSnapshot(
      officeDocRef,
      snapshot => {
        const source = snapshot.metadata.hasPendingWrites ? 'Local' : 'Server';
        console.log('getOffice ' + source + ' snapshot: ' + snapshot.id, snapshot.data());
        const office: Office = { ...(snapshot.data() as Office), _documentId: snapshot.id };
        this.setOffice(office);
        console.log('[data] office', { officePath: this.officePath(), office });
        return office;
      },
      error => {
        console.log('getOffice snapshot jetzt kaputt', error);
      }
    );
  }

  getOfficeTest(userUid: string, onNext: (office: unknown) => unknown, onError: (error: unknown) => unknown) {
    console.log('getOfficeTest');
    const officeDocRef = doc(this.firestore, 'office', userUid);
    onSnapshot(
      officeDocRef,
      snapshot => {
        const source = snapshot.metadata.hasPendingWrites ? 'Local' : 'Server';
        console.log('getOfficeTest ' + source + ' snapshot: ' + snapshot.id, snapshot.data());
        const office: Office = { ...(snapshot.data() as Office), _documentId: snapshot.id };
        console.log('getOfficeTest: ' + this.officePath());

        onNext(office);
      },
      error => {
        console.log('getOfficeTest ERROR : ' + error);
        onError(error);
      }
    );
  }

  getOfficeViaQuery(userUid?: string) {
    console.log('userId: ' + userUid);

    const ref = collection(this.firestore, `office`) as CollectionReference<unknown>;
    // const qc: QueryConstraint[] = [where('author', '==', userUid), orderBy('name', 'desc'), limit(1)];
    const qc: QueryConstraint[] = [where('author', '==', userUid)];
    // if (startAfterTodo) {
    //   qc.push(startAfter(startAfterTodo.id));
    // }

    collectionData(query(ref, ...qc))
      // { idField: undefined }
      // { idField: 'documentId' }
      //collectionData(query(ref, ...qc), 'documentId')
      .pipe(
        map(result => {
          return result.map(item => {
            console.log('office: ', item);
            const office: Office = { ...(item as Office) };
            return office;
          });
        })
      )
      .subscribe((offices: Office[]) => {
        console.log('getOffice result', offices);
        // if (offices.length === 0) {
        //   // create default office for existing users, if none found.
        //   const office: Office = {
        //     name: 'Default Office',
        //     contactData: 'keine Kontakt Daten vorhanden - Praxis wurde automatisch erzeugt',
        //     author: userUid ?? 'fehler',
        //   };
        //   this.createOffice(office).then(result => {
        //     console.log('DEFAULT Office creation successful', result);
        //   });
        // }
        this.setOffice(offices?.[0]);
      });
  }

  getOfficeOld(userUid?: string) {
    console.log('getOffice');

    const officeCollection = collection(this.firestore, 'office');

    const collectionData$ = collectionSnapshots(officeCollection);
    collectionData$
      .pipe(
        map(result => {
          return result.map(snapshot => {
            console.log('snapshot: ' + snapshot.id, snapshot.data());
            const office: Office = { ...(snapshot.data() as Office), _documentId: snapshot.id };
            return office;
          });
        }),
        catchError(error => {
          console.log('getOffice catchError result', error);
          // create default office for existing users, if none found.
          const office: Office = {
            name: 'Default Office',
            contactData: 'keine Kontakt Daten vorhanden - Praxis wurde automatisch erzeugt',
            // author: userUid ?? 'fehler',
          };
          // this.createOffice(office).then(result => {
          //   console.log('DEFAULT Office creation successful', result);
          // });
          return of();
        })
      )
      .subscribe((offices: Office[]) => {
        console.log('getOffice result', offices);
        // if (offices.length === 0) {

        // }
        this.setOffice(offices?.[0]);
      });
  }

  getOfficeData() {
    console.log('getOfficeData');
    const officeCollection = collection(this.firestore, 'office');
    const collectionData$ = collectionData(officeCollection);
    collectionData$
      .pipe(
        map(result => {
          return result.map(data => {
            console.log('getOfficeData data: ', data);
            // const office: Office = { ...(snapshot.data() as Office), _documentId: snapshot.id };
            // return office;
          });
        })
      )
      .subscribe();
  }

  private setOffice(office: Office): void {
    if (office) {
      this.office.set(office);
      // sessionStorage.setItem('Office', JSON.stringify(office));
      localStorage.setItem('Office', JSON.stringify(office));
    }
  }
}
